@if (hasFavorites()) {
  <!-- Favoritos -->
  <app-sidebar-group-title [title]="translateService.getTranslation('OTIMUS4053')" />
  <div
    class="favorites-list"
    data-testid="sidebar-favorites"
  >
    @for (fav of visiblePrograms(); track fav.id) {
      <a
        class="favorite-item"
        [routerLink]="fav.angularPath ? 'app/' + fav.angularPath : ['/gx', fav.systemName]"
        routerLinkActive="favorite-item-active"
        queryParamsHandling="preserve"
      >
        <span class="favorite-label">
          {{ translateService.getTranslation(fav.displayNameCode ?? fav.displayName ?? fav.systemName ?? '') }}
        </span>

        <button
          type="button"
          class="delete-btn"
          (click)="requestDelete($event, fav, deleteFavoriteModal)"
        >
          <span class="material-symbols-outlined delete-icon">delete</span>
        </button>
      </a>
    }
    @if (hasMore()) {
      <!-- Mostrar menos (OTIMUS4423) / Mostrar mais (OTIMUS4424) -->
      <button
        type="button"
        class="favorite-toggle"
        (click)="toggleExpanded()"
      >
        {{ translateService.getTranslation(expanded() ? 'OTIMUS4423' : 'OTIMUS4424') }}
      </button>
    }
  </div>
}

<!-- Remover favorito -->
<oc-modal
  [ocTitle]="translateService.getTranslation('OTIMUS4425')"
  #deleteFavoriteModal
>
  <!-- Tem certeza que deseja remover esta página dos favoritos? -->
  <p>{{ translateService.getTranslation('OTIMUS4426') }}</p>
  <oc-modal-footer>
    <!-- Cancelar -->
    <button
      class="oc button gray-1"
      [disabled]="deleting()"
      (click)="cancelDelete(deleteFavoriteModal)"
    >
      {{ translateService.getTranslation('OTIMUS49') }}
    </button>
    <!-- Confirmar -->
    <button
      class="oc button error"
      [disabled]="deleting()"
      (click)="confirmDelete(deleteFavoriteModal)"
    >
      {{ translateService.getTranslation('OTIMUS83') }}
    </button>
  </oc-modal-footer>
</oc-modal>
